import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, Typography } from "@mui/material";

import SlidingPanel from "react-sliding-side-panel";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import CheckBox from "../../../../../Supporting files/CheckBox/CheckBox";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const Exclusion: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const [clientid, setClientId] = React.useState("");
  const [alternateTreatment, setAlternateTreatment] = React.useState(false);
  const [addQuoteStep, setAddQuoteStep] = React.useState<
    Array<{ insurer: string; premium: string; deleteable: boolean }>
  >([{ insurer: "", premium: "", deleteable: false }]);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  var indents = [];
  for (var i = 0; i < addQuoteStep.length; i++) {
    indents.push(<span className="indent" key={i}></span>);
  }

  const [addexclusion, setAddExclusion] = useState<
    Array<{
      data: Array<{
        id: number;
        checkbox_status: boolean;
        title: string;
        description: string;
      }>;
    }>
  >([
    {
      data: [
        {
          id: 0,
          checkbox_status: false,
          title: "Surgeries",
          description:
            "Any diagnosis of diseases / undergoing of surgery / occurrence of event, whose signs or symptoms first occur within 30 days of Policy Period Start date.",
        },
        {
          id: 1,
          checkbox_status: false,
          title: "Self-Inflicted Injury",
          description:
            "Expenses attributable to self-inflicted injury (resulting from suicide, attempted suicide.",
        },
        {
          id: 2,
          checkbox_status: false,
          title: "Alcohol & Drug Abuse",
          description:
            "Expenses arising out of or attributable to alcohol or drug use/misuse/abuse",
        },
        {
          id: 3,
          checkbox_status: false,
          title: "Pregnancy and Child Birth",
          description:
            "Treatment arising from or traceable to pregnancy and childbirth, miscarriage, abortion and its consequences.",
        },
        {
          id: 4,
          checkbox_status: false,
          title: "Congenital disease.",
          description: "Congenital disease.",
        },
        {
          id: 5,
          checkbox_status: false,
          title: "Man-made Calamities",
          description:
            "War, riot, strike, nuclear weapons induced hospitalisation.",
        },
      ],
    },
  ]);

  const updateMasterStateArray = (attrName: any, value: any) => {
    const array_data = [...addexclusion];

    if (attrName[2] === "value") {
      console.log(attrName, value);
      //array_data[attrName[0]].data[attrName[1]].value = value;
    } else if (attrName[2] === "checkbox_status") {
      array_data[attrName[0]].data[attrName[1]].checkbox_status = value;
    }

    setAddExclusion(array_data);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="slidingPanel"
      // backdropClicked={() => value_update(attrName, false)}
      >
      <>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10} className="pt-3">
            <h4 className="mb-0">Exclusions</h4>
          </Grid>
          <Grid xs={2} textAlign='end' className="mt-2">
              <GridCloseIcon
                onClick={() => {
                value_update(attrName, false);
              }}
              />
            </Grid>
          <Grid xs={12} className="mr-3 pt-0">
            <hr className="mb-0" />
          </Grid>
        </Grid>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={12} className="pt-0">
            <div className="scrollable_area">
              {addexclusion.map((data, index) => (
                <div className={"coverage_section premium_section mr-3 mb-6 "}>
                  <Grid container spacing={3} style={{ alignItems: "center" }}>
                    {data.data.map((value, indexx) => (
                      <>
                        <Grid xs={12} className="checkbox_feature pt-6 pb-6">
                          <CheckBox
                            title={
                              <p>
                                {value.title}
                                <span>{value.description}</span>
                              </p>
                            }
                            name={index.toString() + indexx.toString()}
                            id={index.toString() + indexx.toString()}
                            value={value.checkbox_status}
                            attrName={[index, indexx, "checkbox_status"]}
                            value_update={updateMasterStateArray}
                            default_check={false}
                          />
                        </Grid>
                        <Grid xs={12} className="mb-0 pt-0 pb-0">
                          {indexx + 1 === data.data.length ? null : <hr />}
                        </Grid>
                      </>
                    ))}
                  </Grid>
                </div>
              ))}
            </div>
          </Grid>

          <Grid xs={12} className="footer_sec">
            <Link className="save_btn">Submit</Link>
          </Grid>
        </Grid>
      </>
    </SlidingPanel>
  );
};

export default Exclusion;
